export default __webpack_public_path__ + "static/media/teach-6.a2a56294.jpg";